<template>
  <div class="telegram-bot--container">
    <div v-if="companies.length === 0" class="text-orange text-center">
      Похоже, что вы еще не создали ни одной компании. Необходимо
      выполнить первоначальную настройку сервиса, после чего вам будет
      доступен данный раздел
    </div>

    <div class="shadow-card">
      <div class="text-bold text-center">Привязка Telegram-бота @EnrollerBot для получения сервисных уведомлений</div>
      <div v-if="companies.length > 0" class="telegram-bot--companies shadow-card mrg-t-20">
        <div class="text-bold">Выберите компанию</div>
        <div class="input-block mrg-t-10">
          <select name="" id="select-company" v-model="selectedCompany">
            <option
              v-for="item in companies"
              :key="item.company.id"
              :value="item.company.id"
            >{{item.company.name}} ({{item.company.address}})</option>
          </select>
        </div>
      </div>

      <div class="mrg-t-10 shadow-card">
        <div class="text-bold">Ваша привязка к Телеграм-боту</div>
        <div class="mrg-t-10">
          <div class="table--container">
            <div class="table--header center">
              <div class="status">Статус</div>
              <div class="action">Действие</div>
            </div>
            <div class="table--rows">
              <div class="table--row center">
                <div class="status">
                  <div v-if="+data.main_user.binding === 0" class="text-orange">Не привязан</div>
                  <div v-if="+data.main_user.binding === 1" class="text-success">Привязан</div>
                </div>
                <div class="action">
                  <div @click="showTgMe" v-if="+data.main_user.binding === 0" class="btn btn-sm btn-success">Привязать</div>
                  <div @click="showTgMe" v-if="+data.main_user.binding === 1" class="btn btn-sm btn-orange">Отвязать</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mrg-t-10 shadow-card">
        <div class="text-bold">Привязка доп.аккаунтов</div>
        <div class="mrg-t-10">
          <div v-if="+data.add_users.length === 0">
            <div class="text-center text-orange">
              У вас пока что отсутствуют доп.аккаунты
            </div>
          </div>
          <div v-if="+data.add_users.length > 0">
            <div class="table--container">
              <div class="table--header center">
                <div class="name">Доп.аккаунт</div>
                <div class="status">Статус</div>
                <div class="action">Действие</div>
              </div>
              <div class="table--rows">
                <div class="table--row center" v-for="item in data.add_users" :key="item.id">
                  <div class="name">{{item.name}}</div>
                  <div class="status">
                    <div v-if="+item.binding === 0" class="text-orange">Не привязан</div>
                    <div v-if="+item.binding === 1" class="text-success">Привязан</div>
                  </div>
                  <div class="action">
                    <div @click="showTgAdduser(item.id, item.name)" v-if="+item.binding === 0" class="btn btn-sm btn-success">Привязать</div>
                    <div @click="showTgAdduser(item.id, item.name)" v-if="+item.binding === 1" class="btn btn-sm btn-orange">Отвязать</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mrg-t-10 shadow-card">
        <div class="text-bold">Привязка сотрудников</div>
        <div class="mrg-t-10">
          <div v-if="+data.staffs.length === 0">
            <div class="text-center text-orange">
              У вас пока что отсутствуют сотрудники
            </div>
          </div>
          <div v-if="+data.staffs.length > 0">
            <div class="table--container">
              <div class="table--header center">
                <div class="name">Сотрудник</div>
                <div class="status">Статус</div>
                <div class="action">Действие</div>
              </div>
              <div class="table--rows">
                <div class="table--row center" v-for="item in data.staffs" :key="item.id">
                  <div class="name">{{item.name}}</div>
                  <div class="status">
                    <div v-if="+item.binding === 0" class="text-orange">Не привязан</div>
                    <div v-if="+item.binding === 1" class="text-success">Привязан</div>
                  </div>
                  <div class="action">
                    <div
                      @click="showTgStaff(item.id, item.name)"
                      v-if="+item.binding === 0"
                      class="btn btn-sm btn-success"
                    >Привязать</div>
                    <div
                      @click="showTgStaff(item.id, item.name)"
                      v-if="+item.binding === 1"
                      class="btn btn-sm btn-orange"
                    >Отвязать</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="shadow-card mrg-t-30">
      <div class="text-bold text-center">
        Привязка вашего Telegram-бота для рассылки уведомлений вашим клиентам
      </div>
      <div class="mrg-t-15">
        <div class="input-block">
          <label>
            HTTP API вашего Telegram-бота
            <hints :type="'text'" :title="'Инструкция по интеграции Telegram-бота'">
              <div slot="text">
                <p>
                  Услуга полностью бесплатна. Привязка Telegram-бота позволяет отправлять уведомления вашим клиентам,
                  тем самым экономя на СМС, а так же клиент может быстро получить ссылку на запись, чтобы записаться.
                </p>
                <p>
                  Список команд со временем будет расширяться для удобства ваших клиентов.
                </p>
                <p>
                  Начнем с создания бота. Откройте Telegram на любом устройстве и найдите
                  <span class="text-bold text-orange">@BotFather</span>
                </p>
                <p>Нажмите кнопку <b>Меню</b> и выберите <b>create a new bot</b></p>
                <img width="98%" src="../../../assets/img/tg_bot_instr/1.jpg">
                <p>
                  Сначала вас попросят придумать название бота. Его можно писать на русском языке в свободной форме.
                  Это то название, которое будут видеть ваши клиенты при взаимодействии с ним.
                </p>
                <p>
                  Вам нужно будет придумать никнейм для бота. Данное название должно быть на латинице, а
                  в конце должно быть слово bot. Телеграм вам подскажет, что, например, подойдет TetrisBot или
                  tetris_bot. По данному никнейму вас смогут найти ваши клиенты, поэтому хорошо, если бы никнейм
                  был созвучен с вашей компанией (-ями).
                </p>
                <p>
                  После этого вам придет сообщение с вашим HTTP API токеном, который вам нужно скопировать и
                  вставить в наше интеграционное поле
                </p>
                <img width="98%" src="../../../assets/img/tg_bot_instr/2.jpg">
                <p>
                  Для того, чтобы установить аватарку для вашего Telegram-бота, нажмите опять кнопку <b>Меню</b> и
                  выберите <b>change bot profile photo</b>. Далее, вас могут попросить выбрать кнопкой бота, которому
                  необходимо установить аватарку. Выбираем и после просто отправляем нужную картинку в чат
                </p>
                <img width="98%" src="../../../assets/img/tg_bot_instr/3.jpg">
                <p>
                  Готово! Ваш бот полностью настроен. <b>Не забудьте включить уведомления о записях на вкладке
                  "Уведомления"</b>. Для того, чтобы ваш клиент смог получать уведомления на него,
                  необходимо поделиться с ним ссылкой на бота любым удобным способом, либо же отправить клиенту
                  никнейм бота для самостоятельного поиска.
                  Сценарии могут быть различные. Например, вы можете помогать регистрироваться в боте своим
                  клиентам после первого посещения. Можете сгенерировать QR-код в любом генераторе QR-кодов
                  из поисковика на свой телеграм-бот и повесить его на стойку администратора.
                  При входе, клиент увидит сначалу кнопку <b>СТАРТ</b>,
                  далее, после нажатия, бот попросит поделиться номером телефона нажатием на большую кнопку.
                  После этого привязка будет выполнена. Если же на момент регистрации клиента не существовало в вашей
                  базе, то он будет автоматически создан.
                </p>
                <img width="98%" src="../../../assets/img/tg_bot_instr/4.jpg">
              </div>
            </hints>
          </label>
          <input id="user_bot_token" v-model="userBotToken">
          <div class="hint">
            Обратите внимание, если вы поменяете токен, то все уже привязанные клиенты
            на старый токен, будут отвязаны.
          </div>
        </div>
        <div class="input-block mrg-t-15">
          <div @click="setUserToken" class="btn btn-sm btn-success">
            Сохранить
          </div>
        </div>
      </div>
    </div>


    <popup
      :show="tgMePopup.show"
      :closeButton="tgMePopup.closeButton"
      @closePopup="closeTgMe"
    >
      <div slot="header">Привязка к Телеграм-боту</div>
      <div slot="body">
        <telegram-bot-user :show="tgMePopup.show" @exit="exitTgMe"></telegram-bot-user>
      </div>
    </popup>

    <popup
      :show="tgAdduserPopup.show"
      :closeButton="tgAdduserPopup.closeButton"
      @closePopup="closeTgAdduser"
    >
      <div slot="header">Привязка к Телеграм-боту доп.аккаунта "{{adduserActionName}}"</div>
      <div slot="body">
        <telegram-bot-adduser
          :staffId="adduserActionId"
          :show="tgAdduserPopup.show"
          @exit="exitTgAdduser"
        ></telegram-bot-adduser>
      </div>
    </popup>

    <popup
      :show="tgStaffPopup.show"
      :closeButton="tgStaffPopup.closeButton"
      @closePopup="closeTgStaff"
    >
      <div slot="header">Привязка к Телеграм-боту сотрудника "{{staffActionName}}"</div>
      <div slot="body">
        <telegram-bot-staff
          :staffId="staffActionId"
          :show="tgStaffPopup.show"
          @exit="exitTgStaff"
        ></telegram-bot-staff>
      </div>
    </popup>

  </div>
</template>

<script>

import Popup from '../../Popup.vue';
import TelegramBotUser from './TelegramBotUser.vue';
import TelegramBotAdduser from '../adduser/TelegramBotAdduser.vue';
import TelegramBotStaff from '../staff/TelegramBotStaff.vue';
import Hints from '../../Hints.vue';
import telegramRepository from "../../../repositories/telegram";
import userRepository from "../../../repositories/user";

export default {
  name: "TelegramBot",
  components: {Popup, TelegramBotUser, TelegramBotAdduser, TelegramBotStaff, Hints},
  data() {
    return {
      userBotToken: '',
      tgMePopup: {
        show: false,
        closeButton: 'Закрыть'
      },
      tgAdduserPopup: {
        show: false,
        closeButton: 'Закрыть'
      },
      tgStaffPopup: {
        show: false,
        closeButton: 'Закрыть'
      },
      adduserActionName: '',
      adduserActionId: 0,
      staffActionName: '',
      staffActionId: 0,
      data: {
        add_users: [],
        main_user: {binding: 0},
        staffs: []
      },
      companies: [],
      selectedCompany: 0
    };
  },
  props: {

  },
  watch: {
    companies: function(val){
      // Установим по умолчанию сразу первую компанию, что прилетела
      if(val.length){
        this.selectedCompany = val[0].company.id;
      }
    },
    selectedCompany: function(val){
      this.getTelegramStatus(val);
    }
  },
  computed: {

  },
  methods: {
    setUserToken(){
      this.$store.dispatch("startPreloader");

      telegramRepository.setUserBot({token: this.userBotToken}).then(resp => {
        if(resp.data.result === 'ok'){
          this.$store.dispatch("addNotification", {
            text: 'Успешно сохранено',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    exitTgStaff(){
      this.getTelegramStatus(this.selectedCompany);
      this.closeTgStaff();
    },
    closeTgStaff(){
      this.tgStaffPopup.show = false;
    },
    showTgStaff(staffId, username){
      this.staffActionName = username;
      this.staffActionId = +staffId;
      this.tgStaffPopup.show = true;
    },

    exitTgAdduser(){
      this.getTelegramStatus(this.selectedCompany);
      this.closeTgAdduser();
    },
    closeTgAdduser(){
      this.tgAdduserPopup.show = false;
    },
    showTgAdduser(userId, username){
      this.adduserActionName = username;
      this.adduserActionId = +userId;
      this.tgAdduserPopup.show = true;
    },

    exitTgMe(){
      this.getTelegramStatus(this.selectedCompany);
      this.closeTgMe();
    },
    closeTgMe(){
      this.tgMePopup.show = false;
    },
    showTgMe(){
      this.tgMePopup.show = true;
    },
    getCompanies(){
      this.$store.dispatch("startPreloader");

      userRepository.getCompanyData().then(resp => {
        this.companies = resp.data.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getTelegramStatus(companyId){
      this.$store.dispatch("startPreloader");

      telegramRepository.view({company_id: companyId}).then(resp => {
        this.data = resp.data;
        if(resp.data.user_bot){
          this.userBotToken = resp.data.user_bot.telegram_token;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created(){
    this.getCompanies();
  }
};
</script>

<style scoped lang="less">

</style>
